module.exports = "images/enfants.5f05770b.png";